// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    // Box,
//    // Stepper,
//    // Step,
//    // StepIndicator,
//    // StepStatus,
//    // StepIcon,
//    // StepNumber,
//    // StepTitle,
//    // StepDescription,
//    // StepSeparator,
//    useToast,
//    FormControl,
//    FormLabel,
//    Select,
//    FormErrorMessage,
// } from '@chakra-ui/react';
// import { useDispatch } from 'react-redux';
// import { renderFormControl } from 'utils/DynamicFormData';
// import { getTransport, addTransport, updateTransport } from '../../../../../redux/actions/transport';
// import '../../../companyProfile/css.css';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useGlobal } from 'contexts';
// import { useUser } from 'contexts';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
//    mode: Yup.string().required('Mode is required'),
//    gst: Yup.string()
//       .required('GST is required')
//       .min(15, 'GST must be exactly 15 characters long')
//       .max(15, 'GST must be exactly 15 characters long'),
//    email: Yup.string().email('Invalid email').required('Email is required'),
//    mobile: Yup.string()
//       .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
//       .required('Mobile is required'),
// });

// // const steps = [
// //   { title: 'First', description: 'Enter Item Information' },
// //   { title: 'Second', description: 'Review and Save' },
// // ];

// const TransportMasterForm = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    demoname,
//    currentRow = null,
//    onSave,
//    saveandcontinue = true,
// }) => {
//    const [row, setRow] = useState({
//       name: '',
//       mode: '',
//       gst: '',
//       email: '',
//       mobile: '',
//       compIds: [],
//    });
//    const { user } = useUser();
//    const [errors, setErrors] = useState({});
//    const [isLoading, setIsLoading] = useState(false);
//    // const [activeStep, setActiveStep] = useState(0);
//    const toast = useToast();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.transport;
//    const shouldShowCompanyDropdown = globalSetting || false;
//    const dbName = localStorage.getItem('dbName');
//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);
//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          mode: '',
//          gst: '',
//          email: '',
//          mobile: '',
//       });
//       setErrors({});
//    };

//    useEffect(() => {
//       if (user?.loginhistory?.companyId && !isEditMode) {
//          // Only set if not in edit mode and compIds is empty or doesn't include the user's company
//          setRow((prev) => {
//             if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
//                return {
//                   ...prev,
//                   compIds: [user.loginhistory.companyId],
//                };
//             }
//             return prev;
//          });
//       }
//    }, [user?.loginhistory?.companyId, isEditMode]);

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData(); // Clear data when adding a new item
//          setRow((prev) => ({
//             ...prev,
//             compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
//          }));
//       } else if (isEditMode && currentRow) {
//          setRow({
//             name: currentRow.name || '',
//             mode: currentRow.mode || '',
//             gst: currentRow.gst || '',
//             email: currentRow.email || '',
//             mobile: currentRow.mobile || '',
//             compIds: currentRow.compIds || [],
//          });
//       }
//    }, [isEditMode, currentRow]);

//    const validateStep = async () => {
//       try {
//          // Validate the whole row object instead of individual fields
//          await validationSchema.validate(row, { abortEarly: false });

//          setErrors({}); // Clear previous errors
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));

//       // Clear the specific field error when user starts typing
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    // const handleNext = async () => {
//    //   const isValid = await validateStep();
//    //   if (isValid) {
//    //     if (activeStep < steps.length - 1) {
//    //       setActiveStep(activeStep + 1);
//    //     }
//    //   } else {
//    //     toast({
//    //       title: 'Validation Error',
//    //       description: 'Please correct the errors before proceeding.',
//    //       status: 'error',
//    //       duration: 3000,
//    //       isClosable: true,
//    //     });
//    //   }
//    // };

//    // const handlePrevious = () => {
//    //   if (activeStep > 0) {
//    //     setActiveStep(activeStep - 1);
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          mode: Number(row.mode),
//          compIds: row.compIds,
//          mobile: row.mobile,
//          // storage: Number(row.storage),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateTransport(processedData));
//          } else {
//             // Add new item
//             // await dispatch(addTransport(processedData));
//             const response = await dispatch(addTransport(processedData));
//             if (response?.code === 1) {
//                onSave(response.data);
//             }
//          }
//          dispatch(getTransport());
//          // Close the modal
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the category.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          mode: Number(row.mode),
//          mobile: row.mobile,
//          // storage: Number(row.storage),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateTransport(processedData));
//          } else {
//             // Add new item
//             // await dispatch(addTransport(processedData));
//             const response = await dispatch(addTransport(processedData));
//             clearFormData();
//             if (response?.code === 1) {
//                onSave(response.data);
//             }
//          }
//          dispatch(getTransport());
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the category.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handleCansel = async () => {
//       onClose();
//       if (!isEditMode) {
//          clearFormData();
//       }
//    };

//    useEffect(() => {
//       if (demoname && row.name === '') {
//          setRow((prev) => ({ ...prev, name: demoname }));
//       }
//       demoname = '';
//    }, [demoname, row.name]);

//    const nameInputRef = useRef(null);
//    const savefinishRef = useRef(null);
//    const mobileRef = useRef(null);
//    const emailRef = useRef(null);
//    const modeRef = useRef(null);
//    const gstRef = useRef(null);

//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (isOpen && e.key.toLowerCase() === 's') {
//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S
//             } else {
//                handleSubmit(); // S only
//             }
//          }
//          if (isOpen && e.key.toLowerCase() === 'c') {
//             handleCansel();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             handleCansel();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [handleCansel]);

//    return (
//       <Modal isOpen={isOpen} onClose={handleCansel} size="4xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '20%', md: '10%', xl: '8%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Transport' : 'Add New Transport'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                {/* <Stepper index={activeStep} colorScheme="teal">
//             {steps.map((step, index) => (
//               <Step key={index}>
//                 <StepIndicator>
//                   <StepStatus
//                     complete={<StepIcon />}
//                     incomplete={<StepNumber />}
//                     active={<StepNumber />}
//                   />
//                 </StepIndicator>
//                 <Box flexShrink="0">
//                   <StepTitle>{step.title}</StepTitle>
//                   <StepDescription>{step.description}</StepDescription>
//                 </Box>
//                 <StepSeparator />
//               </Step>
//             ))}
//           </Stepper> */}

//                {/* {activeStep === 0 && ( */}
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }} gap={2}>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            ref: nameInputRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  modeRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'mode',
//                         'mode',
//                         [
//                            { id: 1, name: 'ROAD' },
//                            { id: 2, name: 'RAIL' },
//                            { id: 3, name: 'AIR' },
//                            { id: 4, name: 'SHIP' },
//                         ],
//                         {
//                            value: row.mode,
//                            onChange: (value) => handleInputChange('mode', value),
//                            ref: modeRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  gstRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Mode',
//                      )}
//                      {/* <FormControl
//                 isRequired
//                 isInvalid={errors.mode}
//                 display="flex"
//                 alignItems="center"
//               >
//                 <FormLabel htmlFor="mode" color={textColor} width="60%">
//                   Mode
//                 </FormLabel>
//                 <Select
//                   id="mode"
//                   name="mode"
//                   value={row.mode}
//                   onChange={(e) => handleInputChange('mode', e.target.value)}
//                   placeholder="Select Mode"
//                 >
//                   <option value="1">ROAD</option>
//                   <option value="2">RAIL</option>
//                   <option value="3">AIR</option>
//                   <option value="4">SHIP</option>
//                 </Select>
//                 {errors.mode && (
//                   <FormErrorMessage>{errors.mode}</FormErrorMessage>
//                 )}
//               </FormControl> */}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'gst',
//                         'Gst no',
//                         {
//                            value: row.gst,
//                            onChange: (e) => handleInputChange('gst', e.target.value.toUpperCase()),
//                            ref: gstRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  emailRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'email',
//                         'email',
//                         {
//                            value: row.email,
//                            onChange: (e) => handleInputChange('email', e.target.value),
//                            ref: emailRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  mobileRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'email',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   {shouldShowCompanyDropdown && (
//                      <GridItem className="seperator-width">
//                         {renderDynamicUiDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: row.compIds,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'mobile',
//                         'mobile',
//                         {
//                            value: row.mobile,
//                            onChange: (e) => handleInputChange('mobile', e.target.value),
//                            ref: mobileRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  savefinishRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                </Grid>
//                {/* )} */}

//                {/* {activeStep === 1 && (
//             <Box mt={8}>
//               <strong>Name:</strong> {row.name}
//               <br />
//               <strong>storage:</strong> {row.storage}
//               <br />
//             </Box>
//           )} */}
//             </ModalBody>
//             <ModalFooter>
//                {/* {activeStep > 0 && (
//             <Button
//               onClick={handlePrevious}
//               variant="ghost"
//               colorScheme="teal"
//               mr={3}
//             >
//               Previous
//             </Button>
//           )}

//           {activeStep < steps.length - 1 && (
//             <Button onClick={handleNext} colorScheme="teal">
//               Next
//             </Button>
//           )} */}
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   ref={savefinishRef}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>

//                <Button variant="ghost" onClick={handleCansel} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default TransportMasterForm;

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   useColorMode,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { renderFormControl } from 'utils/DynamicFormData';
import { getTransport, addTransport, updateTransport } from '../../../../../redux/actions/transport';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal } from 'contexts';
import { useUser } from 'contexts';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   mode: Yup.string().required('Mode is required'),
   gst: Yup.string()
      .required('GST is required')
      .min(15, 'GST must be exactly 15 characters long')
      .max(15, 'GST must be exactly 15 characters long'),
   email: Yup.string().email('Invalid email').required('Email is required'),
   mobile: Yup.string()
      .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
      .required('Mobile is required'),
});

const TransportMasterForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   onSave,
   saveandcontinue = true,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [row, setRow] = useState({
      name: '',
      mode: '',
      gst: '',
      email: '',
      mobile: '',
      compIds: [],
   });
   const { user } = useUser();
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const toast = useToast();
   const dispatch = useDispatch();
   const { companyList, userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.transport;
   const shouldShowCompanyDropdown = globalSetting || false;
   const dbName = localStorage.getItem('dbName');

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const clearFormData = () => {
      setRow({
         name: '',
         mode: '',
         gst: '',
         email: '',
         mobile: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            mode: currentRow.mode || '',
            gst: currentRow.gst || '',
            email: currentRow.email || '',
            mobile: currentRow.mobile || '',
            compIds: currentRow.compIds || [],
         });
      }
   }, [isEditMode, currentRow]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         mode: Number(row.mode),
         compIds: row.compIds,
         mobile: row.mobile,
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateTransport(processedData));
         } else {
            const response = await dispatch(addTransport(processedData));
            if (response?.code === 1) {
               onSave(response.data);
            }
         }
         dispatch(getTransport());
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         mode: Number(row.mode),
         mobile: row.mobile,
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateTransport(processedData));
         } else {
            const response = await dispatch(addTransport(processedData));
            clearFormData();
            if (response?.code === 1) {
               onSave(response.data);
            }
         }
         dispatch(getTransport());
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handleCansel = async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
   };

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   const nameInputRef = useRef(null);
   const savefinishRef = useRef(null);
   const cancelRef = useRef(null);
   const savecontinueRef = useRef(null);
   const mobileRef = useRef(null);
   const emailRef = useRef(null);
   const modeRef = useRef(null);
   const gstRef = useRef(null);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            handleCansel();
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleCansel();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleCansel]);

   return (
      <Modal isOpen={isOpen} onClose={handleCansel} size="4xl">
         <ModalOverlay className="backdrop-blur-sm bg-black/30" />
         <ModalContent
            className={`
               ${isDark ? 'bg-gray-800' : 'bg-white'}
               rounded-2xl shadow-2xl mx-4
               ${isDark ? 'border border-gray-700' : 'border border-gray-200'}
            `}
            style={{ marginTop: window.innerWidth < 768 ? '20%' : window.innerWidth < 1280 ? '10%' : '8%' }}>
            {/* Header with gradient */}
            <ModalHeader
               className={`
                  text-xl font-semibold py-5 px-6 rounded-t-2xl
                  ${isDark
                     ? 'bg-gradient-to-r from-blue-900 to-indigo-900 text-white border-b border-gray-700'
                     : 'bg-gradient-to-r from-blue-50 to-indigo-50 text-gray-800 border-b border-blue-200'
                  }
               `}>
               <div className="flex items-center gap-3">
                  <div
                     className={`w-10 h-10 rounded-lg flex items-center justify-center ${isDark ? 'bg-blue-800' : 'bg-blue-500'
                        }`}>
                     <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth={2}
                           d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                     </svg>
                  </div>
                  <span>{isEditMode ? 'Edit Transport' : 'Add New Transport'}</span>
               </div>
            </ModalHeader>

            <ModalCloseButton
               className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-800'} mt-2`}
            />

            <ModalBody className="p-6">
               {/* Transport Information Section */}
               <div className="mb-6">
                  <div
                     className={`
                     flex items-center gap-2 mb-4 pb-2 border-b-2
                     ${isDark ? 'border-indigo-700' : 'border-indigo-300'}
                  `}>
                     <div
                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? 'bg-indigo-900' : 'bg-indigo-100'
                           }`}>
                        <svg
                           className={`w-5 h-5 ${isDark ? 'text-indigo-300' : 'text-indigo-600'}`}
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                           />
                        </svg>
                     </div>
                     <h3 className={`text-lg font-semibold ${isDark ? 'text-indigo-300' : 'text-indigo-700'}`}>
                        Transport Information
                     </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                     {DynamicInput(
                        'name',
                        'Name',
                        {
                           value: row.name,
                           onChange: (e) => handleInputChange('name', e.target.value),
                           ref: nameInputRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 e.preventDefault();
                                 modeRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        isDark ? '#9E9E9E' : '#4B5563',
                        'text',
                        true,
                     )}
                     {renderDynamicDropdown(
                        'mode',
                        'mode',
                        [
                           { id: 1, name: 'ROAD' },
                           { id: 2, name: 'RAIL' },
                           { id: 3, name: 'AIR' },
                           { id: 4, name: 'SHIP' },
                        ],
                        {
                           value: row.mode,
                           onChange: (value) => handleInputChange('mode', value),
                           ref: modeRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 e.preventDefault();
                                 gstRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        isDark ? '#9E9E9E' : '#4B5563',
                        false,
                        'Select Mode',
                     )}
                     {DynamicInput(
                        'gst',
                        'Gst no',
                        {
                           value: row.gst,
                           onChange: (e) => handleInputChange('gst', e.target.value.toUpperCase()),
                           ref: gstRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 e.preventDefault();
                                 emailRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        isDark ? '#9E9E9E' : '#4B5563',
                        'text',
                        true,
                     )}
                  </div>
               </div>

               {/* Contact & Account Section */}
               <div>
                  <div
                     className={`
                     flex items-center gap-2 mb-4 pb-2 border-b-2
                     ${isDark ? 'border-emerald-700' : 'border-emerald-300'}
                  `}>
                     <div
                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? 'bg-emerald-900' : 'bg-emerald-100'
                           }`}>
                        <svg
                           className={`w-5 h-5 ${isDark ? 'text-emerald-300' : 'text-emerald-600'}`}
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                           />
                        </svg>
                     </div>
                     <h3 className={`text-lg font-semibold ${isDark ? 'text-emerald-300' : 'text-emerald-700'}`}>
                        Contact & Account Details
                     </h3>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                     {DynamicInput(
                        'email',
                        'email',
                        {
                           value: row.email,
                           onChange: (e) => handleInputChange('email', e.target.value),
                           ref: emailRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 e.preventDefault();
                                 mobileRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        isDark ? '#9E9E9E' : '#4B5563',
                        'email',
                        true,
                     )}
                     {DynamicInput(
                        'mobile',
                        'mobile',
                        {
                           value: row.mobile,
                           onChange: (e) => handleInputChange('mobile', e.target.value),
                           ref: mobileRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 e.preventDefault();
                                 savefinishRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        isDark ? '#9E9E9E' : '#4B5563',
                        'number',
                        true,
                     )}

                     {shouldShowCompanyDropdown && (
                        <div>
                           {renderDynamicUiDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: row.compIds,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              isDark ? '#9E9E9E' : '#4B5563',
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </div>
                     )}
                  </div>
               </div>
            </ModalBody>

            <ModalFooter
               className={`
               p-6 rounded-b-2xl border-t
               ${isDark ? 'bg-gray-900 border-gray-700' : 'bg-gray-50 border-gray-200'}
            `}>
               <div className="flex gap-3 flex-wrap justify-end w-full">
                  {!isEditMode && saveandcontinue === true && (
                     <Button
                        ref={savecontinueRef}
                        onClick={handlesavecontinue}
                        isLoading={isLoading}
                        disabled={isLoading}
                        className={`
                           px-6 py-2 rounded-lg font-medium transition-all duration-200
                           ${isDark
                              ? 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-lg shadow-indigo-900/50'
                              : 'bg-indigo-500 hover:bg-indigo-600 text-white shadow-lg shadow-indigo-500/30'
                           }
                        `}
                        colorScheme="blue"
                        _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              savefinishRef.current?.focus();
                           }
                        }}>
                        Save & Continue
                     </Button>
                  )}

                  <Button
                     onClick={handleSubmit}
                     isLoading={isLoading}
                     disabled={isLoading}
                     ref={savefinishRef}
                     className={`
                        px-6 py-2 rounded-lg font-medium transition-all duration-200
                        ${isDark
                           ? 'bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg shadow-emerald-900/50'
                           : 'bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-500/30'
                        }
                     `}
                     colorScheme="green"
                     _focus={{ boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.4)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode && saveandcontinue === true) {
                              savecontinueRef.current?.focus();
                           }
                        }
                     }}>
                     Save & Finish
                  </Button>

                  <Button
                     ref={cancelRef}
                     variant="ghost"
                     onClick={handleCansel}
                     className={`
                        px-6 py-2 rounded-lg font-medium transition-all duration-200
                        ${isDark
                           ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
                           : 'text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                        }
                     `}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           savefinishRef.current?.focus();
                        }
                     }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.4)' }}>
                     Cancel
                  </Button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default TransportMasterForm;
